/* eslint-disable guard-for-in */
/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import { Island } from '../island.class';
import islandAssetMap from '../../data/island-asset.map.json';
import { IslandAssetData, IslandAssetProperties } from '../types';

export const getSkuSizeDetailsCfn = (island: Island): [string, IslandAssetProperties] => {
	const assetMap: Record<string, IslandAssetData> = islandAssetMap;
	const width = island.size.width ?? 0;
	let key: string = null;
	let assetData: IslandAssetProperties = null;
	let finish = 'STANDARD'

	// check material for plank charcoal
	if (island.surround.material === 'shiplap' && island.surround.texture === 'Shiplap_Gray_Tile.jpg') finish = 'CHARCOAL';

	if (island.surround.displayName === 'Slat - Walnut' || island.surround.displayName === 'Slat - Charcoal' || island.surround.displayName === 'Slat - Bright') finish = 'SLAT';

	// prices for standard islands - only iterate numeric size keys (1-22)
	for (const size in assetMap[finish]) {
		key = size;
		assetData = assetMap[finish][size];
		if (width > assetData.min && width <= assetData.max) break;
	}

	// Fallback to size '22' if width exceeds max supported size (272)
	if (key && assetData && width > assetData.max) {
		key = '22';
		assetData = assetMap[finish]['22'];
	}

	return [key, assetData];
}
